// Captures coupon codes from URL query params and stashes them in sessionStorage
// so they can be auto-applied when the user reaches the cart.
//
// Supported params (in priority order):
//   ?coupon=LAUNCH50   -> applies LAUNCH50
//   ?utm=launch        -> applies LAUNCH (utm value uppercased)
//   ?utm_campaign=fest -> applies FEST  (campaign value uppercased, only when it
//                                         looks like a coupon code: A-Z0-9_-)
//
// The captured code is stored at: sessionStorage["sp-pending-coupon"].
// Cart page reads + auto-applies it via the existing /api/coupons/validate endpoint.

const STORAGE_KEY = "sp-pending-coupon";

const sanitize = (raw) => {
  if (!raw) return "";
  const code = String(raw).trim().toUpperCase();
  // Only allow safe coupon-shaped codes: 3-30 chars, alphanumerics + _ or -
  if (!/^[A-Z0-9_-]{3,30}$/.test(code)) return "";
  return code;
};

export function captureCouponFromURL() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const candidate =
      params.get("coupon") || params.get("utm") || params.get("utm_campaign");
    const code = sanitize(candidate);
    if (!code) return;
    sessionStorage.setItem(STORAGE_KEY, code);
  } catch (_) {
    // sessionStorage may be unavailable in some privacy modes — fail silently
  }
}

export function readPendingCoupon() {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch (_) {
    return null;
  }
}

export function clearPendingCoupon() {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {
    /* noop */
  }
}
